var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarkdown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 158,
    viewBox: "0 0 256 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M238.371 157.892H18.3952C8.43114 157.892 0 149.461 0 139.497V18.3952C0 8.43114 8.43114 0 18.3952 0H237.605C247.569 0 256 8.43114 256 18.3952V139.497C256 149.461 248.335 157.892 238.371 157.892ZM18.3952 12.2635C15.3293 12.2635 12.2635 15.3293 12.2635 18.3952V139.497C12.2635 143.329 15.3293 145.629 18.3952 145.629H237.605C241.437 145.629 243.737 142.563 243.737 139.497V18.3952C243.737 14.5629 240.671 12.2635 237.605 12.2635C238.371 12.2635 18.3952 12.2635 18.3952 12.2635ZM36.7904 121.102V36.7904H61.3174L85.8443 67.4491L110.371 36.7904H134.898V121.102H110.371V72.8144L85.8443 103.473L61.3174 72.8144V121.102H36.7904ZM190.85 121.102L154.06 80.479H178.587V36.7904H203.114V79.7126H227.641L190.85 121.102Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkdown);
export default __webpack_public_path__ + "static/media/markdown.6fca45ee7d4fb4531c64132bcc3c13b3.svg";
export { ForwardRef as ReactComponent };